import {
	FOLDER_NAME,
	default as folderValidationSchema,
} from '@/components/dialogs/AddFolderSharepointDialog/validationSchema';
import { safelyParseDate } from '@/utils/date';
import { isAfter, isBefore } from 'date-fns';
import * as Yup from 'yup';

export const validationSchema = Yup.object()
	.shape({
		clientId: Yup.string().required('Please select a client.'),
		[FOLDER_NAME]: Yup.string()
			.required('Deal name is required.')
			.max(100, "Deal name can't be more than 100 characters long."),
		policyId: Yup.string().required('Please select a policy'),
		policyTransactionId: Yup.string().required('Please select a policy transaction'),
		policy: Yup.object().nullable(false).required('Please select a policy'),
		transaction: Yup.object().nullable(false).required('Please select a policy transaction'),
		files: Yup.array(),
		describeClaim: Yup.string()
			.required('Please provide a description.')
			.max(100, "Description can't be more than 100 characters long."),
		notes: Yup.string(),
		dateOfLoss: Yup.date()
			.nullable(false)
			.required('Date of loss is required.')
			.test(
				'is-between-dates',
				'Date of loss must be within the policy transaction period',
				function (value) {
					console.log('[validation] parent.transaction', this.parent.transaction);
					if (!this.parent.transaction) {
						return false;
					}
					const {
						EffectiveDate,
						FromDate,
						ToDate,
						PolicyToDate,
						PolicyFromDate,
						PolicyEffectiveDate,
					} = this.parent.transaction;
					console.log(
						'[validation] dates',
						'loss date',
						value,
						'from date',
						FromDate,
						'to date',
						ToDate,
					);

					const effectiveDate = EffectiveDate || PolicyEffectiveDate;
					const toDateValue = ToDate || PolicyToDate;
					const fromDateValue = FromDate || PolicyFromDate;

					const normaliseDate = (date) =>
						new Date(date.getFullYear(), date.getMonth(), date.getDate());

					const fromDate = normaliseDate(
						effectiveDate
							? safelyParseDate(effectiveDate)
							: safelyParseDate(fromDateValue),
					);
					const toDate = normaliseDate(safelyParseDate(toDateValue));
					const lossDate = normaliseDate(safelyParseDate(value));

					return (
						(isAfter(value, fromDate) || fromDate.getTime() == lossDate.getTime()) &&
						(toDate.getTime() == lossDate.getTime() || isBefore(value, toDate))
					);
				},
			),
		dateReported: Yup.date().nullable(false).required('Date reported is required.'),
	})
	.concat(folderValidationSchema([], 'Deal name', 'claim'));
